// import { useEffect, useState } from "react";
// import {
//   Button,
//   Flex,
//   Input,
//   Modal,
//   Spin,
//   Table,
//   Switch,
//   message,
// } from "antd";
// import { SearchOutlined, KeyOutlined } from "@ant-design/icons";
// import UserAccessForm from "./userAccessForm";
// import { fetchRole } from "../../Role/Service/roleService";

// let searchTimeout = null;

// const UserAccess = () => {
//   const [roles, setRoles] = useState([]);
//   const [total, setTotal] = useState(0);
//   const [page, setPage] = useState(1);
//   const [size, setSize] = useState(50);
//   const [search, setSearch] = useState("");
//   const [sortField, setSortField] = useState("createdDate");
//   const [sortOrder, setSortOrder] = useState("descend");

//   const [selectedRole, setSelectedRole] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [messageApi, contextHolder] = message.useMessage();

//   // ================= FETCH ROLES =================
//   const fetchData = async (
//     pageNum = page,
//     pageSize = size,
//     searchText = search,
//     field = sortField,
//     order = sortOrder
//   ) => {
//     setLoading(true);
//     try {
//       const res = await fetchRole({
//         page: pageNum - 1,
//         size: pageSize,
//         search: searchText || "",
//         sort: field,
//         desc: order === "descend",
//       });

//       setRoles(res.data.content || []);
//       setTotal(res.data.totalElements || 0);
//       setPage(pageNum);
//       setSize(pageSize);
//       setSortField(field);
//       setSortOrder(order);
//     } catch {
//       messageApi.error("Network error while fetching roles");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ================= SEARCH (DEBOUNCE) =================
//   useEffect(() => {
//     clearTimeout(searchTimeout);
//     searchTimeout = setTimeout(() => {
//       fetchData(1, size, search);
//     }, 500);
//     return () => clearTimeout(searchTimeout);
//   }, [search]);

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const handleOpenAccess = (role) => {
//     setSelectedRole(role);
//     setIsModalOpen(true);
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setSelectedRole(null);
//   };

//   // ================= COLUMNS =================
//   const columns = [
//     {
//       title: "Role",
//       dataIndex: "roleName",
//       key: "roleName",
//       sorter: true,
//       sortOrder: sortField === "roleName" ? sortOrder : null,
//     },
//     {
//       title: "Organization",
//       dataIndex: ["firm", "name"],
//       key: "organization",
//     },
//     {
//       title: "Status",
//       dataIndex: "active",
//       key: "active",
//       render: (val) => (
//         <Switch
//           checked={val}
//           disabled
//           checkedChildren="Active"
//           unCheckedChildren="Inactive"
//         />
//       ),
//     },
//     {
//       title: "Access",
//       key: "access",
//       align: "center",
//       render: (_, record) => (
//         <Button
//           icon={<KeyOutlined />}
//           size="small"
//           onClick={() => handleOpenAccess(record)}
//         >
//           Edit Access
//         </Button>
//       ),
//     },
//   ];

//   return (
//     <Spin spinning={loading}>
//       <div style={{ width: "100%" }}>
//         {contextHolder}

//         <Flex
//           justify="space-between"
//           align="center"
//           style={{ marginBottom: 16 }}
//         >
//           <div style={{ fontSize: "1rem", fontWeight: 700 }}>User Access</div>
//           <Input
//             placeholder="Search role"
//             prefix={<SearchOutlined />}
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//             style={{ width: 240 }}
//           />
//         </Flex>

//         <Table
//           rowKey="id"
//           columns={columns}
//           dataSource={roles}
//           bordered
//           pagination={{
//             current: page,
//             pageSize: size,
//             total,
//             showSizeChanger: true,
//             onChange: (p, ps) => fetchData(p, ps, search),
//           }}
//           onChange={(pagination, filters, sorter) => {
//             const field = sorter.field || sortField;
//             const order = sorter.order || sortOrder;
//             fetchData(pagination.current, pagination.pageSize, search, field, order);
//           }}
//         />

//         <Modal
//           title={
//             selectedRole
//               ? `Access Permissions — ${selectedRole.roleName}`
//               : "Access Permissions"
//           }
//           open={isModalOpen}
//           onCancel={handleCloseModal}
//           footer={null}
//           width={780}
//           centered
//           destroyOnClose
//         >
//           {selectedRole && (
//             <UserAccessForm role={selectedRole} onSaved={handleCloseModal} />
//           )}
//         </Modal>
//       </div>
//     </Spin>
//   );
// };

// export default UserAccess;

import { useEffect, useState } from "react";
import {
  Button,
  Flex,
  Input,
  Modal,
  Spin,
  Table,
  Switch,
  message,
} from "antd";
import { SearchOutlined, KeyOutlined } from "@ant-design/icons";
import UserAccessForm from "./userAccessForm";
import { fetchRole } from "../../Role/Service/roleService";

let searchTimeout = null;

const UserAccess = () => {
  const [roles, setRoles] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(50);
  const [search, setSearch] = useState("");
  const [sortField, setSortField] = useState("createdDate");
  const [sortOrder, setSortOrder] = useState("descend");

  const [selectedRole, setSelectedRole] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  // ================= FETCH ROLES =================
  const fetchData = async (
    pageNum = page,
    pageSize = size,
    searchText = search,
    field = sortField,
    order = sortOrder
  ) => {
    setLoading(true);
    try {
      const res = await fetchRole({
        page: pageNum - 1,
        size: pageSize,
        search: searchText || "",
        sort: field,
        desc: order === "descend",
      });

      // Filter out ROLE_SUPER_ADMIN — super admin always has full access
      // and must never be locked out by misconfigured permissions.
      const allRoles = res.data.content || [];
      setRoles(allRoles.filter((r) => r.roleName !== "ROLE_SUPER_ADMIN"));
      setTotal((res.data.totalElements || 0) - allRoles.filter((r) => r.roleName === "ROLE_SUPER_ADMIN").length);
      setPage(pageNum);
      setSize(pageSize);
      setSortField(field);
      setSortOrder(order);
    } catch {
      messageApi.error("Network error while fetching roles");
    } finally {
      setLoading(false);
    }
  };

  // ================= SEARCH (DEBOUNCE) =================
  useEffect(() => {
    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(() => {
      fetchData(1, size, search);
    }, 500);
    return () => clearTimeout(searchTimeout);
  }, [search]);

  useEffect(() => {
    fetchData();
  }, []);

  const handleOpenAccess = (role) => {
    setSelectedRole(role);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedRole(null);
  };

  // ================= COLUMNS =================
  const columns = [
    {
      title: "Role",
      dataIndex: "roleName",
      key: "roleName",
      sorter: true,
      sortOrder: sortField === "roleName" ? sortOrder : null,
    },
    {
      title: "Organization",
      dataIndex: ["firm", "name"],
      key: "organization",
    },
    {
      title: "Status",
      dataIndex: "active",
      key: "active",
      render: (val) => (
        <Switch
          checked={val}
          disabled
          checkedChildren="Active"
          unCheckedChildren="Inactive"
        />
      ),
    },
    {
      title: "Access",
      key: "access",
      align: "center",
      render: (_, record) => (
        <Button
          icon={<KeyOutlined />}
          size="small"
          onClick={() => handleOpenAccess(record)}
        >
          Edit Access
        </Button>
      ),
    },
  ];

  return (
    <Spin spinning={loading}>
      <div style={{ width: "100%" }}>
        {contextHolder}

        <Flex
          justify="space-between"
          align="center"
          style={{ marginBottom: 16 }}
        >
          <div style={{ fontSize: "1rem", fontWeight: 700 }}>User Access</div>
          <Input
            placeholder="Search role"
            prefix={<SearchOutlined />}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{ width: 240 }}
          />
        </Flex>

        <Table
          rowKey="id"
          columns={columns}
          dataSource={roles}
          bordered
          pagination={{
            current: page,
            pageSize: size,
            total,
            showSizeChanger: true,
            onChange: (p, ps) => fetchData(p, ps, search),
          }}
          onChange={(pagination, filters, sorter) => {
            const field = sorter.field || sortField;
            const order = sorter.order || sortOrder;
            fetchData(pagination.current, pagination.pageSize, search, field, order);
          }}
        />

        <Modal
          title={
            selectedRole
              ? `Access Permissions — ${selectedRole.roleName}`
              : "Access Permissions"
          }
          open={isModalOpen}
          onCancel={handleCloseModal}
          footer={null}
          width={780}
          centered
          destroyOnClose
        >
          {selectedRole && (
            <UserAccessForm role={selectedRole} onSaved={handleCloseModal} />
          )}
        </Modal>
      </div>
    </Spin>
  );
};

export default UserAccess;